"use client";
import { type FormEvent, useState } from "react";
import { Field } from "../../../../components/fields";
import { Button, ButtonLink, Page, Status, TextLink, styles as s } from "../../../../components/ui";
import { call, errorText } from "../../../../lib/api-client";
import { useSubmit } from "../../../../lib/use-submit";

export function FamilyLoginForm({ lineEnabled }: { lineEnabled: boolean }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const f = useSubmit();
  const submit = (e: FormEvent) => {
    e.preventDefault();
    return f.run(async () => {
      const r = await call<{ needs_selection: boolean }>("POST", "/api/auth/family/login", { email, password });
      if (!r.ok) return f.setError(errorText(r.error));
      window.location.href = r.data.needs_selection ? "/select" : "/";
    });
  };
  return (
    <Page title="ご家族のログイン" lead="ご家族として登録した方は、メールアドレスとパスワード、または LINE でログインしてください。">
      {f.error && <Status tone="error">{f.error}</Status>}
      <form className={s.form} onSubmit={submit}>
        <Field label="メールアドレス" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required />
        <Field label="パスワード" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        <Button type="submit" variant="primary" block disabled={f.busy}>ログインする</Button>
      </form>
      {lineEnabled && (
        <>
          <p className={s.divider}>または</p>
          <ButtonLink variant="line" block href="/liff" external>LINEでログイン</ButtonLink>
        </>
      )}
      <div>
        <TextLink href="/family/reset">パスワードを忘れた方</TextLink>
        <TextLink href="/login">ご本人の方（電話番号でログイン）</TextLink>
      </div>
    </Page>
  );
}
